import { render } from "./Section.vue?vue&type=template&id=03f46c8e"
import script from "./Section.vue?vue&type=script&lang=ts"
export * from "./Section.vue?vue&type=script&lang=ts"
script.render = render

export default script